let _accessToken: string | null = null;

export const setAccessTokenMe = (token: string | null) => {
  _accessToken = token;
};

export const getAccessToken = () => _accessToken;
